import React, { useEffect, useState } from "react";
import InputField from "components/fields/InputField";
import { Button } from "@material-tailwind/react";

import { addNewBanqueApi, updateBanqueApi } from "api/banques";

function BanquesForm({ closePopup, banqueFormAction, showToast, selectedBanque }) {
  const [formData, setFormData] = useState({
    label: "",
    value: "",
  });

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (banqueFormAction === "edite" || banqueFormAction === "show") {
      setFormData({
        label: selectedBanque?.label || "",
        value: selectedBanque?.value || "",
      });
    } else {
      setFormData({
        label: "",
        value: "",
      });
    }
  }, [banqueFormAction, selectedBanque]);

  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSubmit = async () => {
    try {
      setIsLoading(true);

      // Validation
      if (!formData.label.trim()) {
        showToast("error", "Le nom de la banque est requis");
        return;
      }

      if (!formData.value.trim()) {
        showToast("error", "La valeur de la banque est requise");
        return;
      }

      if (banqueFormAction === "add") {
        await addNewBanqueApi(formData);
        showToast("success", "Banque ajoutée avec succès");
      } else if (banqueFormAction === "edite") {
        await updateBanqueApi(formData, selectedBanque._id);
        showToast("success", "Banque modifiée avec succès");
      }
    } catch (error) {
      console.error(error);
      showToast("error", "Une erreur s'est produite");
    } finally {
      setIsLoading(false);
    }
  };

  const isReadOnly = banqueFormAction === "show";

  return (
    <div className="w-full">
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        <InputField
          variant="auth"
          extra="mb-3"
          label="Nom de la banque *"
          placeholder="Entrez le nom de la banque"
          id="label"
          type="text"
          value={formData.label}
          onChange={(e) => handleInputChange("label", e.target.value)}
          disabled={isReadOnly}
        />

        <InputField
          variant="auth"
          extra="mb-3"
          label="Valeur de la banque *"
          placeholder="Entrez la valeur de la banque"
          id="value"
          type="text"
          value={formData.value}
          onChange={(e) => handleInputChange("value", e.target.value)}
          disabled={isReadOnly}
        />
      </div>

      <div className="mt-6 flex justify-end gap-4">
        <Button
          variant="text"
          color="red"
          onClick={() => closePopup()}
          className="mr-1"
        >
          <span>Annuler</span>
        </Button>

        {!isReadOnly && (
          <Button
            variant="gradient"
            color="green"
            onClick={handleSubmit}
            disabled={isLoading}
            className="mr-1"
          >
            <span>
              {isLoading 
                ? "En cours..." 
                : banqueFormAction === "add" 
                  ? "Ajouter" 
                  : "Modifier"
              }
            </span>
          </Button>
        )}
      </div>
    </div>
  );
}

export default BanquesForm;
